import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@fontsource-variable/nunito';
import '@fontsource-variable/source-sans-3';
import '@fontsource-variable/open-sans';
import '@fontsource-variable/figtree';
import '@fontsource-variable/bricolage-grotesque';
import './gb-theme.css';
import './global.css';

import { DatesProvider } from '@mantine/dates';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import 'dayjs/locale/fr';
import { type ReactNode, useEffect, useState } from 'react';

import { AuthProvider } from '@/features/auth/AuthProvider';
import { installAttentionSounds } from '@/lib/attention';

import { AppearanceProvider } from './appearance/AppearanceProvider';
import { createQueryClient } from './queryClient';

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);
  useEffect(() => installAttentionSounds(), []);

  return (
    <QueryClientProvider client={queryClient}>
      <AppearanceProvider>
        <DatesProvider settings={{ locale: 'fr', firstDayOfWeek: 1 }}>
          <Notifications position="bottom-center" />
          <AuthProvider>{children}</AuthProvider>
        </DatesProvider>
      </AppearanceProvider>
    </QueryClientProvider>
  );
}
